// ** Gatsby
import { PortableText } from "@portabletext/react"
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Components
import Box from "../Box"
import CardContainer from "../CardContainer"
import Container from "../Container"
import Heading from "../Heading"
import { serializers } from "../Serializers"
import SwiperSlider from "../SwiperSlider"
import { classNames } from "../../utils/helpers"

const SectionSteps = ({ section }: any) => {
  const { title, subTitle, listItems, tags } = section
  const realtorsCards = tags.includes("realtors-cards")
  const centerTitle = tags.includes("center-title")
  console.log(centerTitle)
  return (
    <Container
      constrainedToBreakPoint
      fullWidthOnMobile
      className={classNames(realtorsCards && "text-center")}
    >
      {subTitle && (
        <Heading
          as="h5"
          className="text-gold-500 text-center w-3/5 mx-auto !block lg:w-full"
        >
          {subTitle}
        </Heading>
      )}
      {title && (
        <Heading
          as="h2"
          className={`${
            centerTitle && "text-center"
          } text-blue-500 text-center w-3/5 mx-auto !block lg:w-full`}
        >
          {title}
        </Heading>
      )}

      <Box className="w-screen lg:w-full px-3 lg:px-0">
        <SwiperSlider
          className="mt-8 lg:mt-12"
          childClassName="rounded-lg max-w-[75%] lg:max-w-[28vw] xl:max-w-[418px] mr-3"
          slidesPerView="auto"
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          navigation={false}
        >
          {listItems.map((item: any, idx: any) => (
            <CardContainer
              key={idx}
              header={
                !realtorsCards && (
                  <GatsbyImage
                    className="w-24 h-24 lg:w-32 lg:h-32 m-8 mb-2"
                    objectFit="contain"
                    image={item?.Image?.asset?.gatsbyImageData}
                    alt={item?.Image?.asset?.altText || "section step"}
                  />
                )
              }
              className="mr-4 lg:mr-0 h-full"
              forceHeight={false}
            >
              <Box
                className={realtorsCards || centerTitle ? "text-center" : ""}
              >
                <Heading as="h6">{item.Label}</Heading>
                <Heading as="h4" className="text-blue-500 !block">
                  {item.title}
                </Heading>
              </Box>
              <Box
                className={realtorsCards || centerTitle ? "text-center" : ""}
              >
                <PortableText
                  components={serializers}
                  value={item._rawContent}
                />
              </Box>
            </CardContainer>
          ))}
        </SwiperSlider>
      </Box>
    </Container>
  )
}

export default SectionSteps
